import PropTypes from 'prop-types'
import React from 'react'
import { DraggableCore } from 'react-draggable'
import styled from 'react-emotion'
import SidebarBreadcrumbs from '../SidebarBreadcrumbs'
import DragTag from './DragTag/DragTag'
import SidebarEmpty from './SidebarEmpty'
import SidebarRow from './SidebarRow'
import suspendUntilLoaded from '../../../utils/suspendUntilLoaded';

const Tree = styled('div')({
  label: 'Tree',
  flex: 1, // full height
  overflow: 'auto' // Scroll
})

export const BoardList = styled(
  ({
    className,
    items,
    folders,
    boardActive,
    dragStart,
    drag,
    dragEnd,
    user
  }) => {
    suspendUntilLoaded(items)
      
    const anon = user.isEmpty || user.isAnonymous
    return (
      <DraggableCore
        onStart={dragStart}
        onDrag={drag}
        onStop={dragEnd}
        handle="[data-id]"
        disabled={anon || !folders}
      >
        <div
          className={className}
          style={{ touchAction: 'initial' }} // override react-dragable hack that breaks android-chrome (https://github.com/mzabriskie/react-draggable/issues/51#issuecomment-103488278)
        >
          <SidebarBreadcrumbs folders={folders} boardActive={boardActive} />

          {items && items.length ? (
            <Tree>
              {items.map((item, i) => (
                <SidebarRow item={item} root={!folders} index={i} key={item.id} />
              ))}
              <DragTag />
            </Tree>
          ) : (
            <SidebarEmpty />
          )}
        </div>
      </DraggableCore>
    )
  }
)({
  label: 'BoardList',
  flex: 1,
  display: 'flex',
  flexDirection: 'column',
  overflow: 'auto' // EDGE
})

BoardList.propTypes = {
  items: PropTypes.array,
  dragStart: PropTypes.func.isRequired,
  drag: PropTypes.func.isRequired,
  dragEnd: PropTypes.func.isRequired,
  user: PropTypes.object.isRequired
}

export default BoardList
